export var stateRequiredHelper = function stateRequiredHelper() {
  var addressRequirements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var addressStatesOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var businessUnitAddressRequirement = addressRequirements.find(function (addressRequirement) {
    return !addressRequirement.Global;
  });
  var addressRequirementGlobal = addressRequirements.find(function (addressRequirement) {
    return addressRequirement.Global;
  });
  var addressRequirement = businessUnitAddressRequirement ? businessUnitAddressRequirement : addressRequirementGlobal;
  var isStateRequiredProperty = addressRequirement && addressRequirement.AdditionalProperties.find(function (configObject) {
    return configObject.Key === 'is_state_required';
  });
  var isStateRequired = addressStatesOptions && addressStatesOptions.length && isStateRequiredProperty ? isStateRequiredProperty.Value || false : false;
  return isStateRequired === 'False' ? false : isStateRequired === 'True' ? true : isStateRequired;
};